const trackingNumberPrefix = '[[trackingNumber]]';
function hasUniqueTrackingUrl(trackingUrl) {
  return trackingUrl.includes(trackingNumberPrefix);
}
function getTrackingUrl(trackingUrl, trackingNumber) {
  return trackingUrl.replace(trackingNumberPrefix, trackingNumber);
}

export { getTrackingUrl, hasUniqueTrackingUrl };
//# sourceMappingURL=TrackingUrl.js.map
